export default __webpack_public_path__ + "static/ohearn-61aa2772ac3774086d2efb88f7e28cd2.jpg";